import {
  APP_SIDEBAR_WIDTH_NARROW_PX,
  APP_SIDEBAR_WIDTH_WIDE_PX,
} from '@monorepo/shared-lib';
import { MenuSize } from 'store/app/enums';

export { APP_SIDEBAR_WIDTH_NARROW_PX, APP_SIDEBAR_WIDTH_WIDE_PX };

export const getAppSidebarWidthPx = (
  menuSize: MenuSize,
  hasSidebar: boolean
): number => {
  if (!hasSidebar) return 0;
  return menuSize === MenuSize.WIDE
    ? APP_SIDEBAR_WIDTH_WIDE_PX
    : APP_SIDEBAR_WIDTH_NARROW_PX;
};

/** Keeps `--app-sidebar-width` in sync with the fixed app sidebar (wide/narrow). */
export const syncAppSidebarWidthCssVar = (widthPx: number): void => {
  document.documentElement.style.setProperty(
    '--app-sidebar-width',
    `${widthPx}px`
  );
};
